<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("operarios") }}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div v-if="listOperarios.length > 0 && respuesta" class="col-md-8 text-right">
                            <label> </label><br>
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <router-link :to="{ name: 'operario', params: { 'idBusiness': this.idBusiness } }">
                                    <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                        {{ $t("agregarOperario") }}
                                    </button>
                                </router-link>
                                <button v-if="hasRestriction78" class="btn btn-warning" @click="showModalPermisos()">
                                    <i class="fa fa-shield-alt"></i> Restricciones Generales
                                </button>
                                <button v-if="idBusiness == 6052" class="btn btn-primary" @click="getBusinessAuthHash">
                                    <i class="fa fa-share-alt"></i> {{ $t("generarBusinessHash") }}
                                </button>
                            </div>
                        </div>

                        <div class="col-md-4 text-right">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                    v-model="searchQuery" @keyup.enter.prevent="searchOperarios">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchOperarios"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{ showResult }}</small>
                            </p>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="listOperarios.length > 0">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>{{ $t("nombre") }}</th>
                                    <th>{{ $t("apellido") }}</th>
                                    <th>{{ $t("telefono") }}</th>
                                    <th>{{ $t("acciones") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="operario in listOperarios">
                                    <td>
                                        <div>{{ operario.name }}
                                            <span style="color: red" v-if="operario.baja == '1'">
                                                [{{ $t("BAJA") }}]
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>{{ operario.surName }}</div>
                                    </td>
                                    <td>
                                        <div>{{ operario.phone }}</div>
                                    </td>
                                    <td style="width: 120px; text-align: center; padding: 5px 10px;">
                                        <router-link
                                            :to="{ name: 'operario', params: { 'idBusiness': idBusiness, 'idOperario': operario.id, 'pag': pag } }">
                                            <a class="btn btn-danger btn-link btn-xs" style="padding: 0;">
                                                <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                                    style="color: orange; margin-right: 10px;"></i>
                                            </a>
                                        </router-link>
                                        <i v-if="computedBusinessHash" class="fas fa-qrcode text-dark"
                                            style="cursor: pointer; margin-left: 10px;"
                                            @click="openOperarioModal(operario)"
                                            v-tooltip.top-center="$i18n.t('enviarQR')"></i>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="alert alert-danger" role="alert" v-else>
                        {{ $t("noHayOperariosEnEsteNegocio") }}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{ 'disabled': pag == 1 }">
                                        <router-link class="page-link"
                                            :to="{ name: 'operarios', params: { pag: pag - 1 } }"
                                            v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                                        <router-link class="page-link"
                                            :to="{ name: 'operarios', params: { pag: n } }">{{ n }}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{ 'disabled': pag == totalPags }">
                                        <router-link class="page-link"
                                            :to="{ name: 'operarios', params: { pag: nextPag } }"
                                            v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <modal name="modal-shift-workers" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
                <div>
                    <div class="modal-header">
                        <h4 style="margin: 0px">{{ $t("enlaceFicharTurnosOperario") }}</h4>
                    </div>
                    <div class="modal-body">
                        <label><strong>{{ $t("enlaceFicharTurnosOperarioDescripcion") }}</strong>
                        </label>

                        <div class="input-group mb-3">
                            <input type="text" class="form-control"
                                :value="`https://www.numier.com/gestion-turnos/auth/login/${businessHash}`" readonly />
                            <button class="btn btn-outline-secondary"
                                @click="copyToClipboard(`https://www.numier.com/gestion-turnos/auth/login/${businessHash}`)">
                                <i class="fas fa-copy"></i>
                            </button>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-secondary" @click="$modal.hide('modal-shift-workers')">
                                <strong>{{ $t("cerrar") }}</strong>
                            </button>
                        </div>
                    </div>
                </div>
            </modal>
            <modal :name="'ver-turnos-operario'" :adaptive="true" height="auto" :clickToClose="true">

                <div>
                    <div class="modal-header"
                        style="display: flex; justify-content: space-between; align-items: center;">
                        <h4 style="margin: 0; line-height: 1.2;">
                            {{ operarioData.name }} {{ operarioData.surName }}
                        </h4>
                        <p @click="closeOperarioModal()">
                            <i class="fas fa-times fa-lg" style="color:#3c3c3c !important;"></i>
                        </p>
                    </div>

                    <div class="modal-body" style="padding: 1.5em;">
                        <div style="margin-bottom: 10pt;">
                            <label>{{ $t('email') }}</label>
                            <span style="color: red;">*</span>
                            <input type="email" class="form-control" v-model="operarioData.email" />
                        </div>

                        <div style="margin-bottom: 10pt;">
                            <label>{{ $t("codigoIdentificacion") }} (DNI) </label>
                            <span style="color: red;">*</span>
                            <input type="text" class="form-control" v-model="operarioData.barcode" />
                        </div>

                        <div style="margin-bottom: 10pt;">
                            <label>{{ $t('codigoTurno') }}</label>
                            <span style="color: red;">*</span>
                            <input type="text" class="form-control" v-model="operarioData.turno" />
                        </div>
                    </div>

                    <div class="modal-footer"
                        style="display: flex; justify-content: flex-end; gap: 10px; padding-top: 15px;">
                        <a v-if="operarioData.id && selectedTpvId" @click="handleDownloadPDF" href="#">
                            <i class="fas fa-download"></i>
                            {{ $t("descargarTurnoQR") }}
                        </a>

                        <button v-if="operarioData.id && selectedTpvId" v-once-click.once="sendTurnPasswordEmail"
                            class="btn btn-primary">
                            <i class="fas fa-paper-plane"></i>
                            {{ $t("enviarEmailTurnoQR") }}
                        </button>
                    </div>
                </div>
            </modal>

             <!-- Modal permisos -->
        <modal name="showPermisos"
               :adaptive="true"
               :scrollable="true"
               height="auto"
               :clickToClose="true"
               :width="getWidthModal">
            <div>
                <div class="permisos-cabecera">
                    <div>
                        <h4 style="margin: 0;">
                            Restricciones del operario
                        </h4>
                        <p style="font-size: 10pt; color: gray; margin: 2px 0 0;">
                            Marque las acciones que el operario no puede realizar
                        </p>
                    </div>
                    <button type="button" class="permisos-cerrar" :title="$t('cerrar')" :aria-label="$t('cerrar')" @click="closeModalPermisos()">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="filtro-operarios">
                    <label class="filtro-operarios__label">{{ $t("operariosAplicar") }}</label>

                    <div class="filtro-operarios__barra">
                        <el-popover v-model="popoverOperarios"
                                    placement="bottom-start"
                                    width="380"
                                    trigger="click"
                                    popper-class="popover-seleccion"
                                    @show="busquedaOperario = ''">

                            <div class="popover-seleccion__cabecera">
                                <el-input v-model="busquedaOperario"
                                          size="small"
                                          clearable
                                          prefix-icon="el-icon-search"
                                          :placeholder="$t('buscarOperario')">
                                </el-input>
                                <div class="popover-seleccion__acciones">
                                    <span class="text-muted">{{ operariosFiltrados.length }} {{ $t('operarios').toLowerCase() }}</span>
                                    <a v-if="operariosFiltrados.length > 0" href="#" @click.prevent="alternarOperariosVisibles()">
                                        {{ todosVisiblesSeleccionados ? $t('ninguno') : $t('seleccionarTodos') }}
                                    </a>
                                </div>
                            </div>

                            <div class="popover-seleccion__lista" v-loading="loadingOperariosRestricciones">
                                <label v-for="op in operariosFiltrados"
                                       :key="op.id"
                                       class="popover-seleccion__item"
                                       :class="{ 'is-activo': idsOperariosRestricciones.includes(op.id) }">
                                    <input type="checkbox" :value="op.id" v-model="idsOperariosRestricciones">
                                    <span class="popover-seleccion__nombre">{{ nombreOperario(op) }}</span>
                                    <span v-if="op.email || op.phone" class="popover-seleccion__meta">{{ op.email || op.phone }}</span>
                                </label>
                                <div v-if="!loadingOperariosRestricciones && operariosFiltrados.length === 0" class="popover-seleccion__vacio">
                                    {{ $t('ningunOperarioCoincide') }}
                                </div>
                            </div>

                            <div class="popover-seleccion__pie">
                                <span class="text-muted">{{ idsOperariosRestricciones.length }} / {{ listOperariosRestricciones.length }} {{ $t('seleccionados') }}</span>
                                <button type="button" class="btn btn-primary btn-sm" @click="popoverOperarios = false">{{ $t('aceptar') }}</button>
                            </div>

                            <button slot="reference" type="button" class="filtro-operarios__boton"
                                    :class="{ 'is-parcial': hayOperariosDesmarcados, 'is-vacio': idsOperariosRestricciones.length === 0 }">
                                <i class="fa fa-users"></i>
                                <span>{{ resumenOperarios }}</span>
                                <i class="fa fa-chevron-down filtro-operarios__chevron"></i>
                            </button>
                        </el-popover>

                        <template v-if="hayOperariosDesmarcados">
                            <el-tag v-for="op in operariosSeleccionadosVisibles"
                                    :key="'op-' + op.id"
                                    closable
                                    size="medium"
                                    class="filtro-operarios__tag"
                                    @close="quitarOperario(op.id)">
                                {{ nombreOperario(op) }}
                            </el-tag>
                            <span v-if="operariosSeleccionados.length > operariosSeleccionadosVisibles.length" class="filtro-operarios__mas"
                                  @click="popoverOperarios = true">
                                +{{ operariosSeleccionados.length - operariosSeleccionadosVisibles.length }} {{ $t('mas') }}
                            </span>
                            <a href="#" class="filtro-operarios__todos" @click.prevent="seleccionarTodosOperariosRestricciones()">
                                <i class="fa fa-undo"></i> {{ $t('todosLosOperarios') }}
                            </a>
                        </template>
                    </div>

                    <div v-if="idsOperariosRestricciones.length === 0" class="filtro-operarios__aviso">
                        <i class="fa fa-exclamation-circle"></i> {{ $t('eligeAlMenosUnOperario') }}
                    </div>
                </div>

                <div v-if="screen.width > 992" class="modal-body">
                    <b-form-group>
                        <template #label>
                            <b-form-checkbox style="margin-left: 9px;"
                                             aria-describedby="listPermisosOperario"
                                             aria-controls="listPermisosOperario"
                                             @change="selectAllPermisos()">
                                {{ checkSelectAllPermisos ? 'Quitar selección' : 'Seleccionar todos' }}
                            </b-form-checkbox>
                        </template>

                        <div class="permisos-grid">
                            <b-form-checkbox v-model="permiso.checked"
                                             v-for="permiso in listPermisosOperario"
                                             :key="permiso.id">
                                {{ permiso.name }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </div>

                <div v-else class="modal-body">
                    <b-form-group>
                        <template #label>
                            <b-form-checkbox style="margin-left: 9px;"
                                             aria-describedby="listPermisosOperario"
                                             aria-controls="listPermisosOperario"
                                             @change="selectAllPermisos()">
                                {{ checkSelectAllPermisos ? 'Quitar selección' : 'Seleccionar todos' }}
                            </b-form-checkbox>
                        </template>

                        <div class="permisos-grid">
                            <b-form-checkbox v-model="permiso.checked"
                                             v-for="permiso in listPermisosOperario"
                                             :key="permiso.id">
                                {{ permiso.name }}
                            </b-form-checkbox>
                        </div>
                    </b-form-group>
                </div>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 10px; padding: 15px 20px 20px;">
                    <button type="button" class="btn btn-secondary" @click="closeModalPermisos()" :disabled="loadingApplyRestrictions">
                        {{ $t('cancelar') }}
                    </button>
                    <button class="btn btn-primary" @click="openConfirmApplyPermisos" :disabled="loadingApplyRestrictions || idsOperariosRestricciones.length === 0">
                        Aplicar
                    </button>
                </div>
            </div>
        </modal>

        <modal name="confirmApplyPermisos"
               :adaptive="true"
               :scrollable="true"
               height="auto"
               :clickToClose="false"
               width="40%">
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">Confirmar aplicación</h4>
                </div>
                <div class="modal-body" style="padding: 1rem 1.5rem;">
                    <p v-if="idsOperariosRestricciones.length === listOperariosRestricciones.length">
                        Se aplicarán las restricciones seleccionadas a todos los operarios del negocio ({{ idsOperariosRestricciones.length }}).
                    </p>
                    <p v-else>
                        Se aplicarán las restricciones seleccionadas a {{ idsOperariosRestricciones.length }} operario(s):
                        <strong>{{ nombresOperariosSeleccionados }}</strong>.
                    </p>
                    <p v-if="!listPermisosOperario.some(p => p.checked)" class="text-danger">
                        No hay ninguna restricción marcada: se quitarán todas las restricciones a estos operarios.
                    </p>
                    <p>Las restricciones que tuvieran antes estos operarios se sustituyen por las marcadas. ¿Está usted seguro?</p>
                </div>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; gap: 10px; padding: 15px 20px 20px;">
                    <button class="btn btn-secondary" @click="closeConfirmApplyPermisos">No</button>
                    <button class="btn btn-primary" @click="applyPermisosToAllOperarios" :disabled="loadingApplyRestrictions">Sí</button>
                </div>
            </div>
        </modal>




        </div>
    </div>
</template>
<script>
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Popover, Input, Tag } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import { mapState } from 'vuex'

export default {
    created() {
        //            this.loading = Loading.service({text: 'Cargando...'});
        this.$store.dispatch("setNameRoute", this.$i18n.t("operarios"));
        this.getBusiness();

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

        if (this.$store.getters.idBusiness) {
            this.idBusiness = this.$store.getters.idBusiness;
        }
    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Popover.name]: Popover,
        [Input.name]: Input,
        [Tag.name]: Tag
    },
    directives: {
        loading: Loading.directive
    },
    data() {
        return {

            loadingGeneral: null,

            loading: false,
            loadingEmail: false,
            listBusinesses: [],
            listOperarios: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
            idBusiness: this.$route.params.idBusiness,
            searchQuery: this.$route.params.query,
            isSearch: false,
            pag: this.$route.params.pag,
            totalPags: 0,
            selectedTpvId: null,
            listBusinesses: [],

            operarioData: {
                idWorker: '',
                name: '',
                email: '',
                barcode: '',
                turno: ''
            },
            inputsDisabled: {
                email: false,
                barcode: false,
                turno: false
            },
            guardando: false,
            respuesta: true,
            businessHash: "",
            hasRestriction78: false,
            checkSelectAllPermisos: false,
            loadingApplyRestrictions: false,
            listOperariosRestricciones: [],
            idsOperariosRestricciones: [],
            loadingOperariosRestricciones: false,
            popoverOperarios: false,
            busquedaOperario: '',
            listPermisosOperario: [],
            listPermisosOperarioInitial: [],
            screen: {
                width: window && window.screen ? window.screen.width : 0,
                height: window && window.screen ? window.screen.height : 0,
            },
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.pag) {
                this.pag = to.params.pag;
                this.getOperarios();
            } else if (to.params.query) {
                this.query = to.params.query;
                this.getOperarios();
            }
        }
    },
    computed: {
        operariosFiltrados() {
            const q = this.normalizarTexto(this.busquedaOperario);
            if (!q) {
                return this.listOperariosRestricciones;
            }
            return this.listOperariosRestricciones.filter(op =>
                this.normalizarTexto(this.nombreOperario(op) + ' ' + (op.email || '') + ' ' + (op.barCode || '')).includes(q));
        },
        todosVisiblesSeleccionados() {
            return this.operariosFiltrados.length > 0
                && this.operariosFiltrados.every(op => this.idsOperariosRestricciones.includes(op.id));
        },
        operariosSeleccionados() {
            return this.listOperariosRestricciones.filter(op => this.idsOperariosRestricciones.includes(op.id));
        },
        operariosSeleccionadosVisibles() {
            return this.operariosSeleccionados.slice(0, 6);
        },
        hayOperariosDesmarcados() {
            return this.idsOperariosRestricciones.length < this.listOperariosRestricciones.length;
        },
        resumenOperarios() {
            const total = this.listOperariosRestricciones.length;
            const n = this.idsOperariosRestricciones.length;
            if (n === 0) {
                return this.$t('ningunOperario');
            }
            if (n === total) {
                return this.$t('todosLosOperarios') + ' (' + total + ')';
            }
            if (n === 1) {
                return this.nombreOperario(this.operariosSeleccionados[0]);
            }
            return n + ' ' + this.$t('deOperarios', { total });
        },
        nombresOperariosSeleccionados() {
            return this.listOperariosRestricciones
                .filter(w => this.idsOperariosRestricciones.includes(w.id))
                .map(w => ((w.name || '') + ' ' + (w.surName || '')).trim())
                .join(', ');
        },
        ...mapState(["permiso"]),
        showResult() {
            if (this.listOperarios.length == 0) {
                return this.$t('noEncontramosResultadosPara') + this.searchQuery;
            } else {
                const result = this.listOperarios.length == 1 ? this.$t('resultado') : this.$t('resultados');
                return this.$t("mostrando") + " " + this.listOperarios.length + " " + result;
            }
        },
        nextPag() {
            let nextPag = parseInt(this.pag) + 1;
            return nextPag;
        },
        urlExportPDF() {

            return "../api/public/index.php/workers/exportListOperarios/PDF?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt

        },
        urlExportExcel() {


            /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
             */
            return "../api/public/index.php/workers/exportListOperarios/Excel?idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
        },
        selectedBusiness() {
            return this.listBusinesses.find(business => business.id === this.idBusiness);
        },
        computedBusinessHash() {
            return this.selectedBusiness && this.selectedBusiness.hash == "1" ? true : false;
        },
        getWidthModal() {
            let defaultWidth = 60;
            const width = this.screen && this.screen.width ? this.screen.width : (window && window.screen ? window.screen.width : 0);
            if (width < 992) {
                defaultWidth = 90;
            }
            return `${defaultWidth}%`;
        },

    },
    methods: {
        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    if (response.data.response) {

                        vm.listBusinesses = response.data.result;

                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }
                        const currentBusiness = vm.listBusinesses.find(b => b.id === vm.idBusiness);
                        vm.selectedTpvId = currentBusiness && currentBusiness.idTpv ? currentBusiness.idTpv : null;

                        vm.getRestrictionsByUser();
                        vm.getOperarios();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        cambioNegocio() {

            this.pag = 1;
            this.totalPags = 0;

            this.getRestrictionsByUser();
            this.getOperarios();
        },
        getOperarios() {

            const controller = this.searchQuery ? 'searchWorkersByBusiness/' + this.searchQuery : 'getWorkersByBusiness';
            var config = {
                params: {
                    pag: this.pag,
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            this.$store.dispatch("setIdBusiness", this.idBusiness);

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "workers/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listOperarios = response.data.result.workers;
                        vm.pag = response.data.result.pag;
                        vm.totalPags = response.data.result.totalPags;

                        vm.respuesta = true;

                        vm.loadingGeneral.close();
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                    // vm.loading.close();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getRestrictionsByUser() {
            const config = {
                params: { jwt: this.$store.getters.jwt },
                headers: { 'Authorization': 'Bearer ' + this.$store.getters.jwt }
            };

            this.axios.get(this.$store.getters.apiUrl + 'general/getRestrictionsByUser', config)
                .then(response => {
                    if (response.data && response.data.response && Array.isArray(response.data.result)) {
                        this.hasRestriction78 = response.data.result.some(
                            r => String(r.idRestriction) === '78'
                        );
                    } else {
                        this.hasRestriction78 = false;
                    }
                })
                .catch(error => {
                    console.error('Error al obtener restricciones:', error);
                    this.hasRestriction78 = false;
                });
        },
        loadPermisosOperario() {
            if (this.listPermisosOperario.length > 0) {
                return Promise.resolve();
            }

            const firstOperario = this.listOperarios.find(o => o && o.id);
            if (!firstOperario) {
                this.listPermisosOperario = [];
                return Promise.resolve();
            }

            const config = {
                params: {
                    idBusiness: this.idBusiness,
                    idOperario: firstOperario.id,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': 'Bearer ' + this.$store.getters.jwt }
            };

            return this.axios.get(this.$store.getters.apiUrl + 'workers/getWorkerById', config)
                .then(response => {
                    if (response.data && response.data.response) {
                        this.listPermisosOperario = response.data.result.permisos || [];
                        this.listPermisosOperarioInitial = JSON.parse(JSON.stringify(this.listPermisosOperario));
                    } else {
                        this.listPermisosOperario = [];
                    }
                })
                .catch(error => {
                    console.error('Error al obtener permisos de operario:', error);
                    this.listPermisosOperario = [];
                });
        },
        loadGeneralPermisos() {
            const firstOperario = this.listOperarios.find(o => o && o.id);
            if (!firstOperario) {
                this.listPermisosOperario = [];
                return Promise.resolve();
            }

            const config = {
                params: {
                    idBusiness: this.idBusiness,
                    idOperario: firstOperario.id,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': 'Bearer ' + this.$store.getters.jwt }
            };

            return this.axios.get(this.$store.getters.apiUrl + 'workers/getWorkerById', config)
                .then(response => {
                    if (response.data && response.data.response) {
                        const permisos = response.data.result.permisos || [];
                        this.listPermisosOperario = permisos.map(p => ({
                            ...p,
                            checked: false
                        }));
                        this.checkSelectAllPermisos = false;
                    } else {
                        this.listPermisosOperario = [];
                    }
                })
                .catch(error => {
                    console.error('Error al obtener permisos generales:', error);
                    this.listPermisosOperario = [];
                });
        },
        selectAllPermisos() {
            if (this.checkSelectAllPermisos) {
                this.listPermisosOperario.forEach(function (permiso) {
                    permiso.checked = false;
                });
                this.checkSelectAllPermisos = false;
            } else {
                this.listPermisosOperario.forEach(function (permiso) {
                    permiso.checked = true;
                });
                this.checkSelectAllPermisos = true;
            }
        },
        searchOperarios() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({ name: 'search-operarios', params: { query: this.searchQuery } });
                this.isSearch = true;
            }
        },
        removeSearch() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                this.isSearch = false;
                this.$router.push({ name: 'operarios' });
                this.getOperarios()
            }
        },
        openShiftWorkerModal() {
            this.$modal.show("modal-shift-workers");
        },
        closeShiftWorkerModal() {
            this.$modal.hide("modal-shift-workers");
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$notify({
                    title: this.$t("enlaceCopiadoAlPortapapeles"),
                    horizontalAlign: "center",
                    type: "success",
                });
            });
        },
        getBusinessAuthHash() {
            const controller = "getBusinessAuthHash";
            const config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            this.axios.get(this.$store.getters.apiUrl + "gestion-turnos/" + controller, config)
                .then(response => {
                    if (response.data && response.data.response && response.data.hash) {
                        this.businessHash = response.data.hash;
                        this.openShiftWorkerModal(this.businessHash);
                    } else {
                        // Generar el hash
                        this.generateBusinessAuthHash();
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        generateBusinessAuthHash() {
            const controller = "generateBusinessAuthHash";

            const config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            var params = {
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            this.axios.post(this.$store.getters.apiUrl + "gestion-turnos/" + controller, params, config)
                .then(response => {
                    if (response.data && response.data.response && response.data.hash) {
                        this.businessHash = response.data.hash;
                        this.openShiftWorkerModal(this.businessHash)
                    } else {
                        swal({
                            title: this.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        },
        openOperarioModal(operario) {
            this.operarioData = {
                id: operario.id || '',
                name: operario.name || '',
                email: operario.email || '',
                barcode: operario.barCode || '',
                turno: operario.turnpassword || '',
                surName: operario.surName || '',
                phone: operario.phone || ''
            };

            this.inputsDisabled = {
                email: !!(this.operarioData.email && this.operarioData.email.trim().length > 0),
                barcode: !!(this.operarioData.barcode && this.operarioData.barcode.trim().length > 0),
                turno: !!(this.operarioData.turno && this.operarioData.turno.trim().length > 0)
            };

            this.guardando = false;

            this.$modal.show('ver-turnos-operario');
        },
        closeOperarioModal() {
            this.$modal.hide("ver-turnos-operario");
        },
        isValidEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        },

        async saveOperario() {
            const controller = "editWorkerTurnById";

            const config = {
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt },
                params: { jwt: this.$store.getters.jwt }
            };

            const params = {
                idBusiness: this.idBusiness,
                idWorker: this.operarioData.id,
                email: this.operarioData.email.trim(),
                barCode: this.operarioData.barcode.trim(),
                turnpassword: this.operarioData.turno.trim()
            };

            // Validaciones locales
            if (!params.email || !params.barCode || !params.turnpassword) {
                swal.fire({
                    icon: 'error',
                    title: this.$t('atencion'),
                    text: this.$t('operarioDatosIncompletos')
                });
                throw new Error("Datos incompletos");
            }

            if (!this.isValidEmail(params.email)) {
                swal.fire({
                    icon: 'error',
                    title: this.$t('atencion'),
                    text: this.$t('emailNoValido')
                });
                throw new Error("Email inválido");
            }

            this.guardando = true;
            this.inputsDisabled.email = true;
            this.inputsDisabled.barcode = true;
            this.inputsDisabled.turno = true;

            try {
                const response = await this.axios.post(
                    this.$store.getters.apiUrl + "workers/" + controller,
                    params,
                    config
                );

                this.guardando = false;
                this.inputsDisabled.email = false;
                this.inputsDisabled.barcode = false;
                this.inputsDisabled.turno = false;

                if (response.data && response.data.response) {
                    this.$modal.hide('ver-turnos-operario');

                    this.$notify({
                        message: this.$t('datosActualizados'),
                        icon: 'nc-icon nc-check-2',
                        timeout: 8000,
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: "success",
                    });

                    this.getOperarios();
                    return true;
                } else {
                    swal.fire({
                        icon: 'error',
                        title: this.$t('error'),
                        text: response.data.message || this.$t('errorActualizar')
                    });
                    throw new Error("Error de API al guardar");
                }
            } catch (error) {
                this.guardando = false;
                this.inputsDisabled.email = false;
                this.inputsDisabled.barcode = false;
                this.inputsDisabled.turno = false;

                if (error.response.data.message) {
                    swal.fire({
                        icon: 'error',
                        title: this.$t('error'),
                        text: error.response.data.message
                    });
                } else {
                    swal.fire({
                        icon: 'error',
                        title: this.$t('error'),
                        text: this.$t('errorActualizar')
                    });
                }

                throw error;
            }
        },

        async sendTurnPasswordEmail() {
            try {
                await this.saveOperario();

                const controller = "generateTurnpasswordQRAndSendEmail";
                const config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idTpv: this.selectedTpvId,
                        idWorker: this.operarioData.id,
                    },
                    headers: {
                        'Authorization': "Bearer " + this.$store.getters.jwt
                    }
                };

                this.loadingEmail = true;

                const response = await this.axios.post(
                    this.$store.getters.apiUrl + "gestion-turnos/" + controller,
                    null,
                    config
                );

                this.loadingEmail = false;

                if (response.data.emailSentNumber > 0) {
                    swal.fire({
                        icon: 'success',
                        title: this.$t('enviado'),
                        text: this.$t('emailEnviado')
                    });
                } else {
                    const errorText = response.data.emailWithErrors.trim() || this.$t('errorEnviarEmail');
                    swal.fire({
                        icon: 'error',
                        title: this.$t('error'),
                        text: errorText
                    });
                }
            } catch (error) {
                this.loadingEmail = false;
                console.warn("Error al guardar o enviar email:", error.message);
                // No mostramos otro swal si ya fue mostrado en saveOperario
            }
        },

        urlDownloadTurnpasswordPDF() {
            return (
                this.$store.getters.apiUrl +
                "/gestion-turnos/exportTurnpasswordQRPDF" +
                "?idWorker=" + this.operarioData.id +
                "&idTpv=" + this.selectedTpvId +
                "&jwt=" + this.$store.getters.jwt
            );
        },

        async handleDownloadPDF() {
            try {
                const saved = await this.saveOperario();

                // Solo si fue guardado correctamente, generamos el enlace
                if (saved === true) {
                    const url = this.urlDownloadTurnpasswordPDF();

                    const link = document.createElement('a');
                    link.href = url;
                    link.download = "turno_qr.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

            } catch (error) {
                console.error("Error guardando operario antes de descargar PDF:", error.message);
                // swal ya fue mostrado en saveOperario si era necesario
            }
        },

        showModalPermisos() {
            Promise.all([this.loadGeneralPermisos(), this.loadOperariosRestricciones()])
                .then(() => {
                    this.$modal.show('showPermisos');
                })
                .catch(() => {
                    this.$modal.show('showPermisos');
                });
        },
        // Todos los operarios activos del negocio (sin paginar), para elegir a cuáles aplicar las restricciones
        loadOperariosRestricciones() {
            const config = {
                params: {
                    pag: 0,
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': 'Bearer ' + this.$store.getters.jwt }
            };

            this.loadingOperariosRestricciones = true;
            return this.axios.get(this.$store.getters.apiUrl + 'workers/getWorkersByBusiness', config)
                .then(response => {
                    const workers = response.data && response.data.response && response.data.result
                        ? (response.data.result.workers || [])
                        : [];
                    this.listOperariosRestricciones = workers
                        .filter(w => w && w.id)
                        .sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')));
                    this.idsOperariosRestricciones = this.listOperariosRestricciones.map(w => w.id);
                    this.loadingOperariosRestricciones = false;
                })
                .catch(error => {
                    console.error('Error al obtener operarios:', error);
                    this.listOperariosRestricciones = [];
                    this.idsOperariosRestricciones = [];
                    this.loadingOperariosRestricciones = false;
                });
        },
        seleccionarTodosOperariosRestricciones() {
            this.idsOperariosRestricciones = this.listOperariosRestricciones.map(w => w.id);
        },
        nombreOperario(op) {
            return op ? ((op.name || '') + ' ' + (op.surName || '')).trim() : '';
        },
        normalizarTexto(texto) {
            return (texto || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
        },
        seleccionarOperariosVisibles() {
            const ids = new Set(this.idsOperariosRestricciones);
            this.operariosFiltrados.forEach(op => ids.add(op.id));
            this.idsOperariosRestricciones = Array.from(ids);
        },
        deseleccionarOperariosVisibles() {
            const visibles = new Set(this.operariosFiltrados.map(op => op.id));
            this.idsOperariosRestricciones = this.idsOperariosRestricciones.filter(id => !visibles.has(id));
        },
        alternarOperariosVisibles() {
            if (this.todosVisiblesSeleccionados) {
                this.deseleccionarOperariosVisibles();
            } else {
                this.seleccionarOperariosVisibles();
            }
        },
        quitarOperario(id) {
            this.idsOperariosRestricciones = this.idsOperariosRestricciones.filter(x => x !== id);
        },
        openConfirmApplyPermisos() {
            this.$modal.show('confirmApplyPermisos');
        },
        closeModalPermisos() {
            this.popoverOperarios = false;
            this.$modal.hide('showPermisos');
        },
        closeConfirmApplyPermisos() {
            this.$modal.hide('confirmApplyPermisos');
        },
        applyPermisosToAllOperarios() {
            const selectedRestrictionIds = this.listPermisosOperario
                .filter(permiso => permiso.checked)
                .map(permiso => permiso.id);

            this.$modal.hide('confirmApplyPermisos');
            this.$modal.hide('showPermisos');

            this.loadingApplyRestrictions = true;

            const controller = 'applyRestrictionsToBusiness';
            const config = {
                headers: { 'Authorization': 'Bearer ' + this.$store.getters.jwt },
                params: { jwt: this.$store.getters.jwt }
            };
            const params = {
                idBusiness: this.idBusiness,
                idsRestrictions: selectedRestrictionIds,
                // Si están todos marcados no se manda la lista: el servidor lo aplica a todos los operarios del negocio
                idsWorkers: this.idsOperariosRestricciones.length === this.listOperariosRestricciones.length
                    ? []
                    : this.idsOperariosRestricciones,
                jwt: this.$store.getters.jwt
            };

            this.axios.post(this.$store.getters.apiUrl + 'workers/' + controller, params, config)
                .then(response => {
                    this.loadingApplyRestrictions = false;
                    const success = response.data && (response.data.response === true || response.data.success === true);
                    if (success) {
                        swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: response.data.message || 'Restricciones aplicadas correctamente.'
                        });
                    } else {
                        swal.fire({
                            icon: 'error',
                            title: this.$t('error'),
                            text: response.data && response.data.message ? response.data.message : 'No se ha podido aplicar las restricciones.'
                        });
                    }
                })
                .catch(error => {
                    this.loadingApplyRestrictions = false;
                    swal.fire({
                        icon: 'error',
                        title: this.$t('error'),
                        text: error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'Error al aplicar las restricciones.'
                    });
                });
        },


    }
}
</script>

<style scoped>
[v-cloak] {
    display: none;
}

.permisos-cabecera {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 20px 10px;
}

.permisos-cerrar {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: #6c757d;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    transition: background .2s, color .2s;
}

.permisos-cerrar:hover,
.permisos-cerrar:focus {
    background: #f1f2f6;
    color: #303133;
    outline: none;
}

.filtro-operarios {
    margin: 4px 20px 0;
    padding: 12px 14px;
    background: #f8f9fb;
    border: 1px solid #eef0f4;
    border-radius: 6px;
}

.filtro-operarios__label {
    display: block;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    color: #9a9a9a;
}

.filtro-operarios__barra {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.filtro-operarios__boton {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 260px;
    height: 38px;
    padding: 0 14px;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    color: #606266;
    font-size: 14px;
    cursor: pointer;
    transition: border-color .2s;
}

.filtro-operarios__boton:hover,
.filtro-operarios__boton:focus {
    border-color: #1E22AA;
    outline: none;
}

.filtro-operarios__boton.is-parcial {
    border-color: #1E22AA;
    color: #1E22AA;
    background: #f4f5fc;
    font-weight: 600;
}

.filtro-operarios__boton.is-vacio {
    border-color: #F56C6C;
    color: #F56C6C;
}

.filtro-operarios__chevron {
    margin-left: auto;
    font-size: 11px;
    opacity: .6;
}

.filtro-operarios__tag {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.filtro-operarios__mas {
    font-size: 13px;
    color: #1E22AA;
    cursor: pointer;
}

.filtro-operarios__todos {
    font-size: 13px;
    color: #909399;
}

.filtro-operarios__todos:hover {
    color: #1E22AA;
    text-decoration: none;
}

.filtro-operarios__aviso {
    margin-top: 8px;
    font-size: 13px;
    color: #F56C6C;
}

.permisos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.permisos-grid b-form-checkbox {
    width: 100%;
}

@media (max-width: 992px) {
    .permisos-grid {
        grid-template-columns: 1fr;
    }
}

tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
    padding: 0 !important;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}
</style>

<style>
/* El popover se pinta fuera del componente: estilos sin scoped, acotados por popper-class */
.popover-seleccion {
    padding: 0 !important;
}

.popover-seleccion__cabecera {
    padding: 12px 12px 8px;
    border-bottom: 1px solid #eef0f4;
}

.popover-seleccion__acciones {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 12px;
}

.popover-seleccion__acciones a {
    color: #1E22AA;
}

.popover-seleccion__lista {
    max-height: 300px;
    min-height: 60px;
    overflow-y: auto;
    padding: 4px 0;
}

.popover-seleccion__item {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 7px 12px;
    cursor: pointer;
    font-weight: normal;
    text-transform: none;
    font-size: 13px;
    color: #303133;
}

.popover-seleccion__item:hover {
    background: #f5f7fa;
}

.popover-seleccion__item.is-activo {
    background: #f4f5fc;
}

.popover-seleccion__item input {
    margin: 0;
    accent-color: #1E22AA;
}

.popover-seleccion__nombre {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.popover-seleccion__meta {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909399;
    font-size: 12px;
}

.popover-seleccion__vacio {
    padding: 18px 12px;
    text-align: center;
    color: #909399;
    font-size: 13px;
}

.popover-seleccion__pie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border-top: 1px solid #eef0f4;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Operarios/Operarios.vue